const getFirstChar = (str) => (
  str ? str.charAt(0) : ''
);

export default getFirstChar;
